<div class="modal active">
  <div class="modal__container modal__container--lg" style="top: 3%; width: auto; max-width: 95vw;">
    <div class="fields">
      <!-- Header -->
      <h2>{{ modalTitle }}</h2>
      <div class="close" (click)="bsModalRef.hide()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>
      <div class="fields__container">
        <form autocomplete="off" name="userManagementForm" #userManagementForm="ngForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
                <div class="table-fields">
                    <div>
                        <div class="license-legend">
                          <span class="legend-item">
                            <span class="legend-box legend-box-expiring"></span>
                            License expiring soon
                          </span>
                          <span class="legend-item">
                            <span class="legend-box legend-box-inactive"></span>
                            Inactive user
                          </span>
                        </div>

                        <div class="table-wrap">
                        <!-- TABLE -->
                          <table>
                          <caption></caption>
                          <thead>
                              <tr>
                                  <th scope="col" class="col-select"></th>

                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('userName')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          User Name
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'userName' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>

                                   <th scope="col" style="cursor:pointer;" (click)="changeSort('systemRoles')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          System Roles
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'systemRoles' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>

                                    <th scope="col" style="cursor:pointer;" (click)="changeSort('groups')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Groups
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'groups' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>




                                   <th scope="col" style="cursor:pointer;" (click)="changeSort('country')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Country
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'country' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>



                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('organizationName')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Org Name
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'organizationName' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>


                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('organizationType')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Org Type
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'organizationType' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>



                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('userState')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Status
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'userState' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>


                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('referenceLicense')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Ref. License
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'referenceLicense' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>
                                   <!-- Agreement type, Agreement duration, Payment status-->
                                   <th scope="col" style="cursor:pointer;" (click)="changeSort('agreementType')">
                                     <div class="header-wrapper">
                                       <div class="header-content">
                                       Agreement Type
                                       </div>
                                       <button type="button" class="sort-btn" [ngClass]="sortColumn === 'agreementType' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                         ⇅
                                       </button>
                                     </div>
                                   </th>
                                   <th scope="col" style="cursor:pointer;" (click)="changeSort('agreementDuration')">
                                     <div class="header-wrapper">
                                       <div class="header-content">
                                       Agreement Duration
                                       </div>
                                       <button type="button" class="sort-btn" [ngClass]="sortColumn === 'agreementDuration' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                         ⇅
                                       </button>
                                     </div>
                                   </th>
                                    <!-- <th scope="col" style="cursor:pointer;" (click)="changeSort('paymentStatus')">
                                     <div class="header-wrapper">
                                       <div class="header-content">
                                       Payment Status
                                       </div>
                                       <button type="button" class="sort-btn" [ngClass]="sortColumn === 'paymentStatus' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                         ⇅
                                       </button>
                                     </div>
                                   </th>-->
                                <!-- Agreement type, Agreement duration, Payment status-->


                                   <th scope="col" style="cursor:pointer;" (click)="changeSort('approvalDate')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Approval Date
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'approvalDate' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>



                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('dueDate')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Expiry date
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'dueDate' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>

                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('userLastLogin')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Last Login
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'userLastLogin' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>

                                  <!--
                                  <th scope="col" style="cursor:pointer;" (click)="changeSort('storage')">
                                      <div class="header-wrapper">
                                          <div class="header-content">
                                          Storage
                                          </div>
                                          <button type="button" class="sort-btn" [ngClass]="sortColumn === 'storage' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                                              ⇅
                                          </button>
                                      </div>
                                  </th>
                                  -->

                              </tr>

                              <!-- FILTER ROW -->
                              <tr class="filter-row" *ngIf="showFilters">
                              <th></th>
                              <th><input type="text" placeholder="User Name" [(ngModel)]="filters.userName" name="filterUserName" (input)="onFiltersChanged()" /></th>
                              <th><input type="text" placeholder="System Roles" [(ngModel)]="filters.systemRoles" name="filterSystemRoles" (input)="onFiltersChanged()" /></th>
                              <th><input type="text" placeholder="Groups" [(ngModel)]="filters.groups" name="filterGroups" (input)="onFiltersChanged()" /></th>
                              <th><input type="text" placeholder="Country" [(ngModel)]="filters.country" name="filterCountry" (input)="onFiltersChanged()" /></th>
                              <th><input type="text" placeholder="Org Name" [(ngModel)]="filters.organizationName" name="filterOrgName" (input)="onFiltersChanged()" /></th>
                              <th><input type="text" placeholder="Org Type" [(ngModel)]="filters.organizationType" name="filterOrgType" (input)="onFiltersChanged()" /></th>

                              <th>
                                  <select [(ngModel)]="filters.userState" name="filterUserState" (change)="onFiltersChanged()">
                                  <option value="">All</option>
                                  <option *ngFor="let s of userStates" [value]="s">{{ s }}</option>
                                  </select>
                              </th>
                            <th><input type="text" placeholder="Ref. License" [(ngModel)]="filters.referenceLicense" name="filterReferenceLicense" (input)="onFiltersChanged()" /></th>
                             <th>
                                 <select [(ngModel)]="filters.agreementType" name="filterAgreementType" (change)="onFiltersChanged()">
                                     <option value="">All</option>
                                     <option *ngFor="let t of agreementTypes" [value]="t">{{ t }}</option>
                                 </select>
                             </th>

                             <th>
                                 <select [(ngModel)]="filters.agreementDuration" name="filterAgreementDuration" (change)="onFiltersChanged()">
                                     <option value="">All</option>
                                     <option *ngFor="let d of agreementDurations" [value]="d">{{ d }}</option>
                                 </select>
                             </th>
                              <!-- <th><input type="text" placeholder="Payment Status" [(ngModel)]="filters.paymentStatus" name="filterPaymentStatus" (input)="onFiltersChanged()" /></th>-->
                             <th>
                                <div style="display:flex; gap:5px; flex-direction:column;">
                                  <input type="date" [(ngModel)]="filters.approvalDateFrom" name="filterApprovalDateFrom" (change)="updateApprovalDateFrom(filters.approvalDateFrom)" />
                                  <input type="date" [(ngModel)]="filters.approvalDateTo" name="filterApprovalDateTo" (change)="updateApprovalDateTo(filters.approvalDateTo)" />
                                </div>
                              </th>

                              <th>
                                <div style="display:flex; gap:5px; flex-direction:column;">
                                  <input type="date" [(ngModel)]="filters.dueDateFrom" name="filterDueDateFrom" (change)="updateDueDateFrom(filters.dueDateFrom)" />
                                  <input type="date" [(ngModel)]="filters.dueDateTo" name="filterDueDateTo" (change)="updateDueDateTo(filters.dueDateTo)" />
                                </div>
                              </th>


                              <th>
                                  <div style="display:flex; gap:5px; flex-direction:column;">
                                  <input type="date" [(ngModel)]="filters.lastLoginFrom" name="filterLastLoginFrom" (change)="updateLastLoginFrom(filters.lastLoginFrom)" />
                                  <input type="date" [(ngModel)]="filters.lastLoginTo" name="filterLastLoginTo" (change)="updateLastLoginTo(filters.lastLoginTo)" />
                                  </div>
                              </th>
                              <!-- <th><input type="text" placeholder="Storage" [(ngModel)]="filters.storage" name="filterStorage" (input)="onFiltersChanged()" /></th> -->
                              </tr>
                          </thead>

                          <tbody>
                            <tr *ngFor="let user of users; let i = index" [ngClass]="getRowClasses(user, i)">
                              <td class="col-select">
                                  <input type="checkbox" [checked]="selected[i]" (change)="toggleRowSelected(i)"(click)=" $event.stopPropagation()" />                               </td>
                              <td class="clamp-1" [attr.title]="user.userName">{{ user.userName }}</td>
                              <td class="clamp-1" [attr.title]="user.systemRoles?.join(', ')">{{ user.systemRoles?.join(', ') || '-' }}</td>
                              <td class="clamp-1" [attr.title]="user.groups?.join(', ')">{{ user.groups?.join(', ') || '-' }}</td>

                              <td class="clamp-1" [attr.title]="user.country">{{ user.country }}</td>
                              <td class="clamp-1" [attr.title]="user.organizationName">{{ user.organizationName }}</td>
                              <td class="clamp-1" [attr.title]="user.organizationType">{{ user.organizationType }}</td>
                              <td>{{ user.userState }}</td>
                              <td class="clamp-1" [attr.title]="user.referenceLicense">{{ user.referenceLicense }}</td>
                               <td class="clamp-1" [attr.title]="user.agreementType">{{ user.agreementType }}</td>
                               <td class="clamp-1" [attr.title]="user.agreementDuration">{{ user.agreementDuration }}</td>
                               <!-- <td class="clamp-1" [attr.title]="user.paymentStatus">{{ user.paymentStatus }}</td> -->
                              <td>{{ user.approvalDate | date:'yyyy-MM-dd' }}</td>
                              <td>{{ user.dueDate | date:'yyyy-MM-dd' }}</td>
                              <td>{{ user.userLastLogin | date:'yyyy-MM-dd HH:mm' }}</td>
                              <!-- <td>{{ user.storage }}</td> -->
                              </tr>
                          </tbody>
                          </table>
                        </div>
                        <!-- TABLE ACTIONS / PAGING -->
                        <div class="filter" style="margin-top:10px; display:flex; justify-content:space-between; align-items:center;">
                            <div>
                                Showing page {{ pageIndex + 1 }} of {{ totalPages }}
                            </div>

                            <div style="display:flex; gap:10px; align-items:center;">
                                <button type="button"
                                        (click)="changePage(pageIndex - 1)"
                                        style="cursor:pointer;"
                                        [disabled]="pageIndex === 0"
                                        class="gray">
                                Previous
                                </button>

                                <button type="button"
                                        (click)="changePage(pageIndex + 1)"
                                        style="cursor:pointer;"
                                        [disabled]="(pageIndex + 1) * pageSize >= totalElements"
                                        class="gray">
                                Next
                                </button>

                                <select [(ngModel)]="pageSize"
                                        name="pageSize"
                                        (ngModelChange)="onPageSizeChange($event)">
                                  <option [value]="10">10</option>
                                <option [value]="25">25</option>
                                <option [value]="50">50</option>
                                </select>
                            </div>

                        </div>

                        <div class="filter" style="margin-top:10px; display:flex; justify-content:space-between; align-items:center;">
                            <div class="filter" style="margin-bottom:5px;">
                                <a (click)="selectAll()" style="cursor:pointer;">Select All</a>
                                <a (click)="deselectAll()" style="cursor:pointer; margin-left:10px;">Deselect All</a>
                                <a (click)="toggleFilters()" style="cursor:pointer; margin-left:10px;">
                                    {{ showFilters ? 'Close Filters' : 'Open Filters' }}
                                </a>
                                <a style="cursor:pointer; color:#2f80ed; background-color: white;" (click)="resetFilters()">Clear Filters</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="fields__btn">
            <button class="gray" (click)="bsModalRef.hide()">Close</button>
            <button (click)="getSelectedUsers().length === 1 ? openUserApprovalSingle(getSelectedUsers()[0]) : openUserApprovalBulk()"
                    [disabled]="getSelectedUsers().length !== 1"
                    [ngClass]="getSelectedUsers().length === 1 ? 'blue' : 'gray no-hover-gray'"
                    >
              Edit
            </button>
            <button (click)="exportUsers()"
                    [disabled]="!atLeastOneRowSelected()"
                    [ngClass]="atLeastOneRowSelected() ? 'blue' : 'gray no-hover-gray'">
                Export
            </button>
            <button (click)="exportLicenseManagementHistory()" class= "blue">
              Export History
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>

<style>


.table-fields .table-wrap{
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 50vh;

}
.table-fields table{
  table-layout: fixed;
  width: 100%;
  min-width: 1000px;
}


.table-fields th,
.table-fields td{
  font-size: 14px;
  padding: 6px 8px;
  line-height: 1.4;
  vertical-align: middle;

  white-space: normal;
  overflow: visible;
  text-overflow: unset;

  word-break: break-word;
}

.table-fields thead th{
  position: sticky;
  height: 30px;

  top: 0;
  background-color: #eeeeee;
  z-index: 3;
}

/* filter row (second header row) */
.table-fields thead tr.filter-row th{
  top: 29px;             /* height of the first header row */
  z-index: 2;
  background-color: #eeeeee;
}

.table-fields td{
  word-break: break-all;
}

.table-fields td.clamp-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-fields th .header-content{
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  max-width: none;
}
.table-fields .col-select {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  text-align: center;
  padding-left: 0;
  padding-right: 0;
}


.selected-row {
    background-color: #e0f0ff !important;
    transition: background 0.1s;
}




.row-expiring {
  background-color: #fff7cc;
}

.row-inactive {
  background-color: #e6e6e6;
}

/* optional hover so rows still feel interactive */
.table-fields tbody tr.row-expiring:hover {
  background-color: #fff1a8;
}

.table-fields tbody tr.row-inactive:hover {
  background-color: #d9d9d9;
}



.license-legend {
  display: flex;
  gap: 16px;
  margin-bottom: 10px;
  font-size: 13px;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-box {
  width: 14px;
  height: 14px;
  border: 1px solid #ccc;
  display: inline-block;
}

.legend-box-expiring {
  background-color: #fff7cc;
}

.legend-box-inactive {
  background-color: #e6e6e6;
}
</style>
